
import {
    Box,
    Stack,
    Typography
} from '@mui/material';

import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

type Props = {
    dealId: string;
};

type DetailRowProps = {
    label: string;
    value: string | number | null | undefined;
    isHighlight?: boolean;
    link?: string | undefined;
};

export function DetailRow({
    label,
    value,
    isHighlight = false,
    link = undefined
}: DetailRowProps) {
    const hasValue = value !== null && value !== undefined && value !== '';

    const { t } = useTranslate();

    return (
        <Box sx={{ py: 1.5 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                <Typography
                    variant="body2"
                    sx={{
                        color: 'text.secondary',
                        fontWeight: 500,
                        minWidth: 120,
                        flexShrink: 0
                    }}
                >
                    {label}
                </Typography>
                <Box sx={{ textAlign: 'right', flex: 1 }}>
                    {hasValue ? (
                        <>
                            {link ? (
                                <Typography
                                    variant="body2"
                                    component="a"
                                    href={link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        color: 'primary.main',
                                        textDecoration: 'none',
                                        fontWeight: 600,
                                        '&:hover': {
                                            textDecoration: 'underline'
                                        }
                                    }}
                                >
                                    {value}
                                </Typography>
                            ) : (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: isHighlight ? 'text.primary' : 'text.secondary',
                                        fontWeight: isHighlight ? 600 : 400
                                    }}
                                >
                                    {value}
                                </Typography>
                            )}
                        </>
                    ) : (
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.disabled',
                                fontStyle: 'italic'
                            }}
                        >
                            {t('common.not_specified')}
                        </Typography>
                    )}
                </Box>
            </Stack>
        </Box>
    );
}
